import React, { useState, useEffect } from "react";
import { Input, Button, Select, message, Form } from "antd";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { getCustomerData } from "../../../API/User/customer";
import "./style.css";
import { addHighRiskActivity } from "../../../API/User/highriskactivity";

const AddHighRisk = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [recoveryCompanyOptions, setRecoveryCompanyOptions] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [isCustomerSelected, setIsCustomerSelected] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const payload = {
        vehicle_id: values.vehicle,
        status: values.status,
        reason: values.reason,
      };

      const response = await addHighRiskActivity(payload);
      messageApi.success(response?.message);

      setTimeout(() => {
        form.resetFields();
        navigate("/theft");
      }, 800);
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Failed to add high risk activity",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setSaved(false);
    message.info("Changes canceled");
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await getCustomerData();
      const customersData = response?.data?.customers || [];

      const formattedCustomers = customersData.map((item) => ({
        label: item.customer_name,
        value: item.id,
      }));

      setCustomers(customersData);
      setCustomerOptions(formattedCustomers);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error("Failed to load customers");
    }
  };

  const handleCustomerChange = (customerId) => {
    const selectedCustomer = customers.find((c) => c.id === customerId);

    const vehicles = selectedCustomer?.vehicles || [];
    setVehicleOptions(
      vehicles.map((v) => ({
        label: v.vehicle_name,
        value: v.id,
      })),
    );

    const rc = selectedCustomer?.recovery_company;

    setRecoveryCompanyOptions(
      rc ? [{ label: rc.company_name, value: rc.id }] : [],
    );

    setIsCustomerSelected(true);

    form.setFieldsValue({
      vehicle: undefined,
    });
  };

  const statusOptions = [
    { label: "Verified ", value: "verified" },
    { label: "Suspected", value: "suspected" },
    { label: "Unverified", value: "unverified" },
  ];

  return (
    <div className="add-risk">
      {contextHolder}
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <div className="high-risk-container">
          <div className="heading">High Risk Activity</div>

          <div className="risk-details">
            <div className="input-group">
              <div className="title">Select Customer</div>
              <Form.Item
                name="customer"
                rules={[
                  { required: true, message: "Please select a customer!" },
                ]}
              >
                <Select
                  placeholder="Select Customers"
                  options={customerOptions}
                  onChange={handleCustomerChange}
                />
              </Form.Item>
            </div>
            <div className="input-group">
              <div className="title">Vehicle</div>
              <Form.Item
                name="vehicle"
                rules={[
                  { required: true, message: "Please select a vehicle!" },
                ]}
              >
                <Select
                  options={vehicleOptions}
                  placeholder="Select Vehicle"
                  disabled={!isCustomerSelected}
                />
              </Form.Item>
            </div>
            {/* <div className="input-group">
              <div className="title">Location</div>
              <Form.Item
                name="location"
                rules={[{ required: true, message: "Please enter location!" }]}
              >
                <Input placeholder="Add Location" />
              </Form.Item>
            </div> */}
            <div className="input-group">
              <div className="title">Status</div>
              <Form.Item
                name="status"
                rules={[{ required: true, message: "Please select status!" }]}
              >
                <Select placeholder="Select Status" options={statusOptions} />
              </Form.Item>
            </div>
            {/* <div className="input-group">
              <div className="title">Risk Score</div>
              <Form.Item
                name="riskScore"
                rules={[
                  {
                    required: true,
                    message: "Please enter risk score!",
                  },
                ]}
              >
                <Input placeholder="Enter risk score" />
              </Form.Item>
            </div> */}
            <div className="input-group">
              <div className="title">Reason</div>
              <Form.Item name="reason">
                <Input placeholder="Enter Reason" />
              </Form.Item>
            </div>
          </div>
        </div>

        <div className="high-risk-container company-selector">
          <div className="heading">Select Recovery Company</div>
          <div className="title">Recovery Company</div>
          <Form.Item
            name="recoveryCompany"
            rules={[
              {
                required: true,
                message: "Please select a Recovery Company!",
              },
            ]}
          >
            <Select
              placeholder="Select Recovery Company"
              options={recoveryCompanyOptions}
              disabled={!isCustomerSelected}
            />
          </Form.Item>
        </div>
        <div className="form-actions">
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            className="save-btn"
            type="primary"
            htmlType="submit"
            loading={loading}
          >
            Add High-Risk
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default AddHighRisk;
